<script lang="ts">
  import ModalShell from './ModalShell.svelte'
  import { fuzzyFilter, type Command } from '../lib/commands'
  import { formatShortcut } from '../lib/platform'

  interface Props {
    commands: Command[]
    onClose: () => void
  }
  let { commands, onClose }: Props = $props()

  let query = $state('')
  let visible = $derived(fuzzyFilter(commands, query))
  let selected = $state(0)

  $effect(() => {
    void visible
    selected = 0
  })

  function run(cmd: Command): void {
    onClose()
    void cmd.run()
  }

  function onKey(e: KeyboardEvent): void {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      selected = Math.min(selected + 1, visible.length - 1)
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      selected = Math.max(selected - 1, 0)
    } else if (e.key === 'Enter') {
      e.preventDefault()
      const c = visible[selected]
      if (c) run(c)
    }
  }
</script>

<ModalShell variant="palette" label="Commands" onClose={onClose}>
  <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
  <div class="palette" role="group" onkeydown={onKey}>
    <!-- svelte-ignore a11y_autofocus -->
    <input class="search" autofocus type="text" placeholder="Search commands…" bind:value={query} />
    <ul>
      {#each visible as cmd, i (cmd.id)}
        <li>
          <button class:active={i === selected} onclick={() => run(cmd)}>
            <span>{cmd.title}</span>
            {#if cmd.shortcut}<kbd>{formatShortcut(cmd.shortcut)}</kbd>{/if}
          </button>
        </li>
      {:else}
        <li class="empty">No matches</li>
      {/each}
    </ul>
  </div>
</ModalShell>

<style>
  .palette {
    width: min(480px, 92vw);
    padding: var(--space-2);
  }
  .search {
    width: 100%;
    padding: 10px 12px;
    border: none;
    border-bottom: 1px solid var(--border-subtle);
    font: inherit;
    font-size: var(--text-base);
    background: transparent;
    outline: none;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: var(--space-1);
    max-height: 50vh;
    overflow-y: auto;
  }
  li button {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    border: none;
    border-radius: var(--radius-sm);
    background: transparent;
    font: inherit;
    font-size: var(--text-sm);
    text-align: left;
    cursor: pointer;
    color: var(--text-primary);
  }
  li button.active,
  li button:hover {
    background: var(--accent-soft);
  }
  kbd {
    font-family: var(--font-mono);
    font-size: var(--text-xs);
    color: var(--text-muted);
  }
  .empty {
    padding: var(--space-4);
    text-align: center;
    color: var(--text-muted);
    font-size: var(--text-sm);
  }
</style>
